const shortToFullMap: Record<string, string> = {
	af: "af-ZA",
	am: "am-ET",
	ar: "ar-SA",
	az: "az-AZ",
	be: "be-BY",
	bg: "bg-BG",
	bn: "bn-IN",
	bs: "bs-BA",
	ca: "ca-ES",
	cs: "cs-CZ",
	cy: "cy-GB",
	da: "da-DK",
	de: "de-DE",
	el: "el-GR",
	en: "en-US",
	es: "es-ES",
	et: "et-EE",
	fa: "fa-IR",
	fi: "fi-FI",
	fil: "fil-PH",
	fr: "fr-FR",
	ga: "ga-IE",
	gl: "gl-ES",
	gu: "gu-IN",
	he: "he-IL",
	hi: "hi-IN",
	hr: "hr-HR",
	hu: "hu-HU",
	id: "id-ID",
	is: "is-IS",
	it: "it-IT",
	ja: "ja-JP",
	jv: "jv-ID",
	km: "km-KH",
	kn: "kn-IN",
	ko: "ko-KR",
	lo: "lo-LA",
	lt: "lt-LT",
	lv: "lv-LV",
	ml: "ml-IN",
	mr: "mr-IN",
	ms: "ms-MY",
	nb: "nb-NO",
	ne: "ne-NP",
	nl: "nl-NL",
	no: "no-NO",
	pa: "pa-IN",
	pl: "pl-PL",
	pt: "pt-PT",
	ro: "ro-RO",
	ru: "ru-RU",
	si: "si-LK",
	sk: "sk-SK",
	sl: "sl-SI",
	sq: "sq-AL",
	sr: "sr-RS",
	sv: "sv-SE",
	sw: "sw-KE",
	ta: "ta-IN",
	te: "te-IN",
	th: "th-TH",
	tr: "tr-TR",
	uk: "uk-UA",
	ur: "ur-PK",
	vi: "vi-VN",
	zh: "zh-CN",
	zu: "zu-ZA",
};

const fullToShortMap: Record<string, string> = Object.fromEntries(
	Object.entries(shortToFullMap).map(
		([short, full]: [string, string]): [string, string] => [full, short],
	),
);

export const bcp47Helper = (
	language: string,
	form: "short" | "full" = "full",
): string => {
	if (!language) return form === "short" ? "en" : "en-US";

	const key = language.replace("_", "-");
	const isFull = key.includes("-");

	if (isFull) {
		if (form === "short") return fullToShortMap[key] || "en";
		return key || "en";
	}

	if (form === "full") return shortToFullMap[key] || "en-US";
	return key || "en-US";
};
